import styled, { css } from 'styled-components';
import MaskedInput from 'react-text-mask';
import {
  cvGray,
  cvWhite,
  cvBlue,
  cvGreen,
  cvRed,
  cvFontFamily
} from '@carvana/theme';
import AlertCircle from '@carvana/icons/AlertCircle';
import CheckCircle from '@carvana/icons/CheckCircle';

const iconOffSet = '10px';

export const CheckmarkIcon = styled(CheckCircle)`
  color: ${cvGreen('primary')};
  position: absolute;
  top: ${iconOffSet};
  right: ${iconOffSet};
  width: 15px;
  height: 15px;
`;

export const PasswordToggler = styled.div`
  display: none;
  cursor: pointer;
  position: absolute;
  font-weight: 700;
  color: ${cvBlue('primary')};
  font-size: 12px;
  right: 10px;
  bottom: 10px;
  text-transform: uppercase;

  &:hover {
    display: block;
  }
`;

export const ErrorIcon = styled(AlertCircle)`
  color: ${cvRed('primary')};
  width: 15px;
  height: 15px;
  position: absolute;
  top: ${iconOffSet};
  right: ${iconOffSet};
`;

const hideValdiationIconsWhenFocused = css`
  &:focus ~ ${CheckmarkIcon} {
    display: none;
  }
`;

const showPasswordToggleWhenFocused = css`
  &:focus ~ ${PasswordToggler}, &:hover ~ ${PasswordToggler} {
    display: block;
  }
`;

export const FormControl = styled.div<{
  multiline?: boolean;
}>`
  font-family: ${cvFontFamily};
  position: relative;
  display: flex;
  flex-flow: column;
  width: 100%;

  ${props => (props.multiline ? css`
    height: 150px;
  ` :
    css`
    height: 60px;
  `
  )}

  &.is-disabled {
    cursor: not-allowed;
    background-color: ${cvGray('background')};

    label {
      color: ${cvGray('light')};
    }
  }

  &.show-error-icon {
    input {
      border-color: ${cvRed('primary')};
    }

    label {
      color: ${cvRed('primary')};
    }
  }

  &.is-focused:not(.show-error-icon) {
    label {
      color: ${cvBlue('primary')};
    }
  }

  input::-webkit-credentials-auto-fill-button {
    display: none !important;
  }
  input::-ms-clear, input::-ms-reveal {
    display: none;
  }
  input:-internal-autofill-selected {
    -webkit-text-fill-color: ${cvGray('dark')};
  }

  &.is-populated, &.is-focused {
    label {
      transform: translate(17px, 14px) scale(1);
      font-weight: 700;
      font-size: 10px;
    }
  }
`;

const inputCss = css`
  color: ${cvGray('dark')};
  background: ${cvWhite('primary')};
  border: 1px solid ${cvGray('light')};
  padding: 1rem 1rem 0 1rem;
  flex: 1;
  border-radius: 3px;
  outline: none;
  font-size: 14px;
  appearance: none;
  background-clip: padding-box;

  @keyframes onAutoFillStart {};
  @keyframes onAutoFillCancel {};

  &:-webkit-autofill {
    animation-name: onAutoFillStart;
    transition: background-color 50000s ease-in-out 0s;
  }

  &:not(:-webkit-autofill) {
    animation-name: onAutoFillCancel;
  }


  &:disabled {
    cursor: not-allowed;
    background: ${cvGray('background')};
  }

  &:focus {
    border: 1px solid ${cvBlue('primary')};
  }

  ${hideValdiationIconsWhenFocused}
  ${showPasswordToggleWhenFocused}
`;

export const TextMaskedInput = styled(MaskedInput)`
  ${inputCss}
`;

export const FormInput = styled.input`
  ${inputCss}
`;

export const TextArea = styled.textarea`
  ${inputCss}
  padding-top: 2rem;
  resize: none;
`;

export const Label = styled.label`
  position: absolute;
  text-transform: uppercase;
  color: ${cvGray('dark')};
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
  transform: translate(15px, 23px) scale(1);
  pointer-events: none;
  user-select: none;
  margin: 0;
  transition: all 150ms ease-in-out;
`;

export const ErrorMessageContainer = styled.div`
  font-family: ${cvFontFamily};
  color: ${cvRed('primary')};
  font-weight: 400;
  font-size: 14px;
  margin-top: 5px;
`;
